import React from 'react';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const before = ['Armar las clases desde cero cada semana', 'No saber qué enseñar según el nivel', 'Falta de materiales actualizados', 'Estrés por planificar todo el año'];
const after = ['Planificación anual completa y lista', 'Actividades progresivas por nivel', 'Contenidos organizados por tomo', 'Clases resueltas en minutos'];
const metrics: [string, string, string][] = [['12', 'TOMOS', 'text-brand-orange'], ['6 a 18', 'AÑOS', 'text-brand-purple'], ['100%', 'LISTO', 'text-brand-teal']];
export function TransformationSection() {
  return <section className="bg-brand-main px-4 py-20 md:py-28" data-id="element-168" data-mp="29830fxax1jjo">
      <Reveal className="mx-auto max-w-5xl" data-id="element-169" data-mp="299mgpnwknulg">
        <div className="mx-auto max-w-3xl text-center" data-id="element-170" data-mp="248qedervcgi5">
          <p className="mb-4 text-xs font-extrabold tracking-[0.18em] text-brand-teal" data-id="element-171" data-mp="2486uhsinri1h">
            UNA MEJOR FORMA DE ENSEÑAR MÚSICA
          </p>
          <h2 className="text-4xl font-black leading-[1.08] tracking-tight text-brand-blue md:text-5xl" data-id="element-172" data-mp="fakehl7x46u4">
            De Docente Abrumado a{' '}
            <span className="italic text-brand-orange" data-id="element-173" data-mp="k3dig6vkbb55">Guía Musical con Confianza.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-brand-gray md:text-base" data-id="element-174" data-mp="5eprkdwnvplj">
            Dejá de improvisar tus clases de música y empezá a enseñar con seguridad, semana a
            semana.
          </p>
        </div>

        <div className="mx-auto my-12 grid max-w-3xl divide-y divide-brand-dark overflow-hidden rounded-2xl border border-brand-dark bg-brand-alt shadow-sm sm:grid-cols-3 sm:divide-x sm:divide-y-0" data-id="element-175" data-mp="130epdx8oflbq">
          {metrics.map(([value, label, color]) => <div key={label} className="px-5 py-5 text-center" data-id="element-176" data-mp="t0nuvvk496bn">
              <strong className={`block font-serif text-3xl leading-none ${color}`} data-id="element-177" data-mp="39quxe172dpd4">{value}</strong>
              <span className="mt-2 block text-[10px] font-extrabold leading-tight tracking-[0.08em] text-brand-gray" data-id="element-178" data-mp="3dsyaeu9dt20i">
                {label}
              </span>
            </div>)}
        </div>

        <div className="overflow-hidden rounded-3xl border border-brand-dark bg-brand-alt shadow-[0_18px_45px_rgba(22,56,107,0.10)]" data-id="element-179" data-mp="1fbxmczuts7zw">
          <div className="grid md:grid-cols-2" data-id="element-180" data-mp="1ai35s5aio951">
            <Comparison title="ANTES" items={before} positive={false} data-id="element-181" data-mp="15luw37f39859" />
            <Comparison title="CON MÚSICA LISTA" items={after} positive data-id="element-182" data-mp="11jhrimc2vga2" />
          </div>
          <div className="border-t border-brand-dark bg-brand-main px-6 py-4 text-center text-xs font-semibold text-brand-gray" data-id="element-183" data-mp="11h50ljocdvkv">
            Un pack completo de música para preparar menos y enseñar con más confianza.
          </div>
        </div>
      </Reveal>
    </section>;
}
function Comparison({
  title,
  items,
  positive
}: {
  title: string;
  items: string[];
  positive: boolean;
}) {
  const Icon = positive ? CheckCircle2Icon : XCircleIcon;
  return <div className={`p-6 md:p-9 ${positive ? 'border-t border-brand-dark bg-brand-alt md:border-l md:border-t-0' : 'bg-[#FDF1F0]'}`} data-id="element-184" data-mp="2h0rlwjj3k1do">
      <div className="mb-7 flex items-start justify-between gap-4" data-id="element-185" data-mp="2tiu9k7eprv3y">
        <div data-id="element-186" data-mp="2th14uxnnvkyl">
          <p className={`text-[10px] font-extrabold tracking-[0.16em] ${positive ? 'text-brand-green' : 'text-brand-red'}`} data-id="element-187" data-mp="2tghin4qzaaer">
            {positive ? 'EL SISTEMA LISTO PARA USAR' : 'EL COSTO DE EMPEZAR DE CERO'}
          </p>
          <h3 className="mt-2 font-serif text-2xl font-bold tracking-tight text-brand-blue" data-id="element-188" data-mp="26jfzm0e8m14a">
            {title}
          </h3>
        </div>
        <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-white shadow-md ${positive ? 'bg-brand-green' : 'bg-brand-red'}`} data-id="element-189" data-mp="2am2kfhchqlrz">
          <Icon className="h-5 w-5" aria-hidden="true" data-id="element-190" data-mp="2kjqpp17q3boe" />
        </div>
      </div>
      <ul className="space-y-2.5" data-id="element-191" data-mp="3qx6l90nr5gp7">
        {items.map(item => <li key={item} className={`flex items-center gap-3 rounded-xl px-3 py-3 ${positive ? 'bg-brand-main' : 'bg-brand-alt/70'}`} data-id="element-192" data-mp="3vx2q1249xc5t">
            <Icon className={`h-4 w-4 shrink-0 ${positive ? 'text-brand-green' : 'text-brand-red'}`} aria-hidden="true" data-id="element-193" data-mp="18qq3slq86qh9" />
            <span className={`text-sm leading-snug ${positive ? 'font-semibold text-brand-text' : 'text-brand-gray'}`} data-id="element-194" data-mp="1hqcsc6xuw1sw">
              {item}
            </span>
          </li>)}
      </ul>
    </div>;
}